
export const preloadedValues = {
  prPFUfdeId: "",
    prPFPrecoPauta:0,
    prPFPrecoTabeladoMaximo:0,
    prPFPrecoListaNegativa:0,
    prPFPrecoListaPositiva:0,
    prPFPrecoListaNeutral:0,
};
